import { themeAutomator } from './themeAutomator';
export const getInternalTheme = (colorsScheme) => {
    return themeAutomator(colorsScheme, true);
};
export const getAutomatedStyleProp = (prop, defaultValue) => {
    return ({ theme }) => {
        var _a, _b;
        if (!theme.automated) {
            return defaultValue;
        }
        return ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b[prop]) || defaultValue;
    };
};
//# sourceMappingURL=utils.js.map